// JOBE-0199: shared empty-state for routes whose feature flag is off.
// Replaces the raw `<p>… not enabled</p>` fallback in feature-gated
// pages (Command Center, PromptOps) with a card that explains what's
// happening and offers a styled link to the Feature Flags admin page
// so testers can flip the flag without leaving the UI.

import { Link } from 'react-router-dom';
import './DisabledRoutePlaceholder.css';

export function DisabledRoutePlaceholder({ featureName, flagId, children }) {
  return (
    <div
      className="disabled-route-placeholder"
      data-testid="disabled-route-placeholder"
    >
      <div className="disabled-route-card">
        <div className="disabled-route-kicker">FEATURE FLAG</div>
        <h2 className="disabled-route-title">{featureName}</h2>
        <p className="disabled-route-body">
          {children || (
            <>
              This area is not yet enabled. Enable it on the{' '}
              <Link className="disabled-route-link" to="/admin/feature-flags">
                Feature Flags
              </Link>{' '}
              page or ask your admin.
            </>
          )}
        </p>
        {flagId && (
          <p className="disabled-route-flagid">
            <code>{flagId}</code>
          </p>
        )}
      </div>
    </div>
  );
}

export default DisabledRoutePlaceholder;
